<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher une accreditation..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
<!-- Reference Column -->
<ng-container matColumnDef="reference">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Reference</th>
    <td mat-cell *matCellDef="let element"> {{ element.reference }}</td>
</ng-container>

<!-- Organisme Column -->
<ng-container matColumnDef="organisme">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Organisme</th>
    <td mat-cell *matCellDef="let element"> {{ element.organisme }}</td>
</ng-container>

<!-- Date Obtention Column -->
<ng-container matColumnDef="dateObtention">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Obtention</th>
    <td mat-cell *matCellDef="let element"> {{ element.dateObtention | date: 'shortDate' }}</td>
</ng-container>

<!-- Date Expiration Column -->
<ng-container matColumnDef="dateExpiration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Expiration</th>
    <td mat-cell *matCellDef="let element"> {{ element.dateExpiration | date: 'shortDate' }}</td>
</ng-container>

<!-- Logo Column -->
<ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Logo</th>
    <td mat-cell *matCellDef="let element">
      <!-- Vérifie si 'element.logo' existe et appelle la méthode getSafeImageUrl() pour obtenir l'URL de l'image -->
      <img *ngIf="element.logo" [src]="getSafeImageUrl(element.logo)" alt="Logo" width="200" height="200">
    </td>
  </ng-container>

  <ng-container matColumnDef="documentation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Documentation</th>
    <td mat-cell *matCellDef="let element"> {{ element.documentation }}</td>
</ng-container>

<!-- Laboratory Column -->
<!-- Laboratory Column 
<ng-container matColumnDef="laboratoryId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Laboratoire </th>
    <td mat-cell *matCellDef="let element"> 
        {{ getLaboName(element.laboratoryId) }}
    </td>
  </ng-container>
  -->


                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                               <!--  <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>-->
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Accreditation
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="saveUpdatedTypeAnalyse()">
                <div class="row">
                    <!-- Reference -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Reference</mat-label>
                            <input matInput formControlName="reference" placeholder="Ex. REF-1234">
                            <mat-error *ngIf="editForm.get('reference')?.hasError('required')">Reference is required</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Organisme -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Organisme</mat-label>
                            <input matInput formControlName="organisme" placeholder="Ex. National Accreditation Body">
                            <mat-error *ngIf="editForm.get('organisme')?.hasError('required')">Organisme is required</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Date Obtention -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Date Obtention</mat-label>
                            <input matInput type="date" formControlName="dateObtention" placeholder="MM/DD/YYYY">
                            <mat-error *ngIf="editForm.get('dateObtention')?.hasError('required')">Date Obtention is required</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Date Expiration -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Date Expiration</mat-label>
                            <input matInput  type="date" formControlName="dateExpiration" placeholder="MM/DD/YYYY">
                            <mat-error *ngIf="editForm.get('dateExpiration')?.hasError('required')">Date Expiration is required</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Laboratory ID
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Laboratory</mat-label>
                            <mat-select formControlName="laboratoryId">
                                <mat-option *ngFor="let lab of laboratorie" [value]="lab.id">
                                    {{ lab.raisonSociale }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="editForm.get('laboratoryId')?.hasError('required')">Laboratory is required</mat-error>
                        </mat-form-field>
                    </div>
 -->
                    <!-- Logo -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Logo</mat-label>
                            <input matInput formControlName="logo" placeholder="Ex. Logo URL">
                            <mat-error *ngIf="editForm.get('logo')?.hasError('required')">Logo is required</mat-error>
                        </mat-form-field>
                    </div>
              <!-- documentation -->
              <div class="col-sm-6">
                <mat-form-field class="mb-25">
                  <mat-label>Documentation</mat-label>
                  <textarea matInput formControlName="documentation" placeholder="Ex. Documentation" rows="4"></textarea>
                  <mat-error *ngIf="editForm.get('documentation')?.hasError('required')">
                    Documentation is required
                  </mat-error>
                </mat-form-field>
              </div>
              

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-primary btn-sm">Modifier</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>



<ng-template #viewModal let-modal>

</ng-template>

<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Nouvelle Accréditation</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="saveAcc()">
        <div class="row">
          <!-- Référence -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25">
              <mat-label>Référence</mat-label>
              <input matInput formControlName="reference" placeholder="Ex. REF123">
              <mat-error *ngIf="form.get('reference')?.hasError('required')">La référence est requise</mat-error>
            </mat-form-field>
          </div>

          <!-- Organisme -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25">
              <mat-label>Organisme</mat-label>
              <input matInput formControlName="organisme" placeholder="Ex. Organisme X">
              <mat-error *ngIf="form.get('organisme')?.hasError('required')">L'organisme est requis</mat-error>
            </mat-form-field>
          </div>

          <!-- Date d'Obtention -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25">
              <mat-label>Date d'obtention</mat-label>
              <input matInput type="date" formControlName="dateObtention">
              <mat-error *ngIf="form.get('dateObtention')?.hasError('required')">La date d'obtention est requise</mat-error>
            </mat-form-field>
          </div>

          <!-- Date d'Expiration -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25">
              <mat-label>Date d'expiration</mat-label>
              <input matInput type="date" formControlName="dateExpiration">
              <mat-error *ngIf="form.get('dateExpiration')?.hasError('required')">La date d'expiration est requise</mat-error>
            </mat-form-field>
          </div>

<!-- Logo -->
<div class="col-sm-6">
    <label for="logo">Logo (URL)</label>
    <input type="text" id="logo" formControlName="logo" class="form-control">
    <mat-error *ngIf="form.get('logo')?.hasError('required')">Le logo est requis</mat-error>
  </div>
  
  <div class="col-sm-6">
    <mat-form-field class="mb-25">
      <mat-label>Documentation</mat-label>
      <textarea matInput formControlName="documentation" placeholder="Ex. Documentation" rows="4"></textarea>
    </mat-form-field>
  </div>
          <!-- Laboratory ID
          <div class="col-sm-6">
            <mat-form-field class="mb-25">
              <mat-label>Laboratoire</mat-label>
              <mat-select formControlName="laboratoryId">
                <mat-option *ngFor="let matrice of laboratorie" [value]="matrice.id">
                    {{ matrice.raisonSociale }}
                </mat-option>
            </mat-select>              
            <mat-error *ngIf="form.get('laboratoryId')?.hasError('required')">Le laboratoire est requis</mat-error>
            </mat-form-field>
          </div> -->

          <!-- Bouton Sauvegarder -->
          <div class="col-sm-12 text-right">
            <button type="submit" class="btn btn-success btn-sm" >Sauvegarder</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>


<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
